module.exports = __webpack_public_path__ + "img/banner3.8a6dd741.png";